export const beliefs = [
  {
    label: "The Authority of Scripture",
    content: [
      {Subject: "Belief:", Info: "The Bible is the inspired, infallible, and authoritative Word of God. It is the final rule for faith and practice."},
      {Subject: "Scripture:", Info: "Both the Old and New Testaments are the complete revelation of God, and they are fully trustworthy and sufficient for guiding our Christian life."}
    ]
  },
  {
    label: "The Trinity",
    content: [
      {Subject: "Belief:", Info: "There is One God, eternally existing in three persons: Father, Son, and Holy Spirit."},
      {Subject: "Doctrine:", Info: "Each person of the Trinity is fully and equally God, yet they are distinct from one another."}
    ]
  },
  {
    label: "The Person and Work of Jesus Christ",
    content: [
      {Subject: "Belief:", Info: "Jesus Christ is fully God and fully man, born of the Virgin Mary, and lived a sinless life."},
      {Subject: "Work:", Info: "His death on the cross was a substitutionary atonement for sin, and He was resurrected bodily from the dead. His resurrection ensures eternal life for believers."},
      {Subject: "Return:", Info: "Jesus will return in glory to judge the living and the dead, and to establish His eternal kingdom."}
    ]
  },
  {
    label: "Salvation by Grace Through Faith",
    content: [
      {Subject: "Belief:", Info: "Salvation is a gift from God, granted by grace alone, received through faith alone, and not by any human works or merit."},
      {Subject: "Redemption:", Info: "Jesus Christ's death and resurrection provide the basis for forgiveness and reconciliation with God."},
      {Subject: "Regeneration:", Info: "The Holy Spirit transforms believers, giving them new spiritual life and empowering them to live according to God’s will."}
    ]
  },
  {
    label: "The Holy Spirit",
    content: [
      {Subject: "Belief:", Info: "The Holy Spirit is the third person of the Trinity, who convicts the world of sin, empowers believers for service, and indwells the Christian."},
      {Subject: "Purpose:", Info: "The Holy Spirit guides believers into truth, sanctifies them, and equips them with spiritual gifts."},
    ]
  },
  {
    label: "The Church",
    content: [
      {Subject: "Belief:", Info: "The Church is both Universal and Local, the body of Christ, composed of all true believers in Jesus Christ."},
      {Subject: "Purpose:", Info: "The Church exists to worship God, proclaim the gospel, edify believers, and serve the world in love."},
      {Subject: "Ordinances:", Info: "The Church practices baptism by immersion and the Lord's Supper (communion) as symbolic acts of faith and obedience."},

      {Subject: "The Church’s Mission:", Info: "The New Testament outlines several key purposes for which the church exists:"},
      {Subject: "Worship:", Info: "The primary purpose of the church is to glorify God through worship (Ephesians 5:19-20)."},
      {Subject: "Evangelism:", Info: "The church is tasked with spreading the Gospel and making disciples (Matthew 28:19-20)."},

      {Info: "Membership in the church involves several critical elements:"},
      {Subject: "Repentance and Faith:", Info: "Entrance into the church requires genuine repentance from sin and faith in Jesus Christ (Acts 2:38)."},
      {Subject: "Baptism:", Info: "Public confession through baptism symbolizes one’s commitment to Christ and inclusion in His body (Acts 2:41)."},
      {Subject: "Adherence to Doctrine:", Info: "Members are expected to adhere to sound doctrine. (2 Timothy 4: 1-5)."}
    ]
  },
  {
    label: "The Kingdom of God and Christ’s Return",
    content: [
      {Subject: "Belief:", Info: "God's Kingdom is both a present reality and a future hope."},
      {Subject: "Return:", Info: "Jesus will return to establish God's Kingdom in its fullness, bringing justice, peace, and the final defeat of evil."}
    ]
  },
  {
    label: "Humanity and Sin",
    content: [
      {Subject: "Belief:", Info: "All human beings are created in the image of God but have fallen into sin through disobedience to God, resulting in spiritual death and separation from God."},
      {Subject: "Need for Salvation:", Info: "All people need to be reconciled to God through the salvation offered in Jesus Christ."},

      {Subject: "We believe:", Info: "God created Adam and Eve in His image as male and female, thus the gift of two different yet complementary sexes reflects the goodness of God’s creation."},
      {Info: "However, because Adam and Eve voluntarily rebelled, as their descendants we are born under the condemnation of sin and also inherit a sin nature."},
      {Info: "Therefore, sin has affected the whole of our being, leaving us morally and spiritually \"dead in [our] trespasses and sins\""},
      {Info: "Only through God’s saving work in Jesus Christ can we be rescued, renewed, and reconciled to God. (Romans 5:12; Ephesians 2:1–3)"},

      {Subject: "We Believe:", Info: "Since humanity is the crowning work of God’s creation, each human being is created in His image, is sacred, and is worthy of respect and Christian love."},
      {Info: "This respect must be accorded to all human life from the moment of conception until natural death. (Psalm 139:13–16; Revelation 5:9–10)"},

      {Subject: "We believe:", Info: "God has commanded that no intimate sexual activity should be engaged in outside of a marriage between a man and a woman."},
      {Info: "We believe that any form of homosexuality, lesbianism, bisexuality, bestiality, incest, fornication, adultery, and pornography are sinful perversions of God’s gift of sex."},
      {Info: "(Genesis 2:24; 19:5,13; 26:8-9; Leviticus 18:1-30; Romans 1:26-29; 1 Corinthians 5:1; 6:9; 1 Thessalonians 4:1-8; Hebrews 13:4)"},
    ]
  },
  {
    label: "Eternal Destiny",
    content: [
      {Subject: "Belief", Info: "After death, people face eternal life or eternal separation from God."},
      {Subject: "Eternal Life", Info: "Believers in Christ will enjoy eternal life with God in His presence."},
      {Subject: "Eternal Separation", Info: "Those who reject Christ face eternal punishment and separation from God."}
    ]
  },
  {
    label: "Evangelism and Mission",
    content: [
        {Subject: "Belief:", Info: "Christians are called to share the gospel with others, making disciples of all nations and spreading the message of salvation through Jesus Christ."},
    ]
  },
  {
    label: "Christian Living and Ethics",
    content: [
        {Subject: "Belief:", Info: "Christians are called to live holy lives, following the teachings of Jesus Christ and the moral teachings of Scripture."},
        {Subject: "Sanctification:", Info: "The process by which a believer grows in spiritual maturity and Christlikeness, empowered by the Holy Spirit."},
    ]
  },
  {
    label: "The Second Coming of Christ and Final Judgment",
    content: [
      {Subject: "Belief:", Info: "Christ will return to earth in the future to judge all people, rewarding believers with eternal life and condemning unbelievers to eternal punishment."},

      {Subject: "We believe:", Info: "God, in His own time and in His own way, will bring this present era to a close."},
      {Info: "According to His promise, our Lord Jesus Christ will return imminently, personally, and bodily for His church and also for the establishment of His kingdom on earth."},
      {Info: "For believers, we believe in a pre-tribulational rapture of the church."},
      {Info: "His coming is their blessed hope and demands constant expectancy, holy living, and sacrificial service. (1 Thessalonians 4:13–18; Titus 2:11–14; 2 Peter 3:8–14)"},

      {Subject: "We believe:", Info: "When the future millennial kingdom is established, the national promises given to Abraham will be fulfilled and Israel shall be restored to the glory predicted in the Scriptures, with Christ ruling from Jerusalem."},
      {Info: "As expressed in Habakkuk 2:14, \"For the earth will be filled with the knowledge of the glory of the Lord as the waters cover the sea.\""},
      {Info: "(Isaiah 2:2–5; Jeremiah 31:35–37; Zechariah 14:1–5; Luke 1:30–33; Acts 1:6–7; Romans 11:25–27; Galatians 3:9, 14, 23–29)"},

      {Subject: "We Believe:", Info: "The pre-millennial return of Christ to establish His earthly reign is an important doctrine of eschatology."},
      {Info: "All who teach and preach in the Church are expected to do so consistent with this interpretation of end-time events."},
      {Info: "However, those with a different understanding of the coming kingdom are permitted to join our membership."},
    ]
  }
];